import React, { useMemo } from 'react';

import SupplierContractTermCreateFrom from './SupplierContractTermCreateFrom';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

import { useToast } from 'Hooks/useToast';

export default function SupplierContractTermCreateModal(props) {
    const toast = useToast();

    const close = () => {
        props.modal.hide();
    };

    const onCreated = () => {
        close();
        props.onCreated();
        toast.success($t('The updates were successful. Cashflows are being updated in the background and may take several minutes to complete'));
    };

    return useMemo(
        () => (
            <Modal id={props.id} modal={props.modal} containerStyle={{ maxWidth: '1280px' }}>
                {/* Titled from the row that opened the modal, not the fetched terms: those arrive a
                    request later, so reading them alone made every edit open as "Add Contract
                    Terms" and flip once the spinner cleared. Both row shapes are checked — the
                    contracts listings load the `term` relation, the suppliers listing only
                    `withExists('term')` — with `terms.id` as the fallback. */}
                <ModalHeader
                    title={props.contract?.term || props.contract?.term_exists || props.terms?.id ? $t('Edit Contract Terms') : $t('Add Contract Terms')}
                    close={close}
                ></ModalHeader>
                <div className="tw-rounded-b">
                    {props.isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <div className="modal__form-container">
                            <SupplierContractTermCreateFrom
                                id={props.modalId}
                                contract={props.contract}
                                terms={props.terms}
                                users={props.users}
                                storeUrl={props.storeUrl}
                                updateUrl={props.updateUrl}
                                updateQuantitiesUrl={props.updateQuantitiesUrl}
                                onSuccess={onCreated}
                                onCancel={close}
                                onDeleteAttachment={props.onDeleteAttachment}
                                onDownloadAttachment={props.onDownloadAttachment}
                                onQuantitiesUpdated={props.onQuantitiesUpdated}
                                onRefreshContracts={props.onRefreshContracts}
                                eventStartDate={props.eventStartDate}
                                eventEndDate={props.eventEndDate}
                            />
                        </div>
                    )}
                </div>
            </Modal>
        ),
        [props.contract, props.terms, props.users, props.isLoading],
    );
}
